import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=411285a4"
import script from "./AppTabs.vue?vue&type=script&lang=js"
export * from "./AppTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports